import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: ['text-tag-md', 'bg-black', 'pb-1', 'pt-2', 'text-white', 'wings-black'],
});

export default ArticleDisclosureLabel;
